








import { Component, Prop, Mixins } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import CProdProvInjectorMixin from "@/mixins/cProdProvInjectorMixin";

@Component({
  components: {
    "cprod-prov-actions": () =>
      import("@/components/app/global/contractProducts/cProdProvActions.vue")
  }
})
export default class CProdProvActionsComponent extends Mixins(
  CProdInjectorMixin,
  CProdProvInjectorMixin
) {
  // Props
  @Prop({
    required: true,
    validator: tag => ["u-aside", "u-section-box"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get isVisible() {
    return !!this.cProdProvData.cProdProvFunctions?.length;
  }

  public get i18n() {
    const { entity } = this.cProdData;
    return {
      title: this.$t("_.manage_your_entity", { entity }),
      description: this.$t("_sentence.cprod.provision_actions_context", {
        entity
      })
    };
  }
}
